/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetPunchingPressureEntry } from '../../models/set-punching-pressure-entry';

export interface SetPunchingPressure$Params {
  articleId: number;
      body: SetPunchingPressureEntry
}

export function setPunchingPressure(http: HttpClient, rootUrl: string, params: SetPunchingPressure$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, setPunchingPressure.PATH, 'post');
  if (params) {
    rb.path('articleId', params.articleId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

setPunchingPressure.PATH = '/api/v1/SecondaryMaterial/{articleId}/SetPunchingPressure';
